/** @jsx jsx */

import { css, jsx } from '@emotion/core';

import { Link, Text } from '@zapier/design-system';

import { Colors } from '@zapier/checkout/src/constants';
import { formatCompanyName } from './formatCompanyName';

type Props = {
  accountName?: string | null | undefined;
  companyName?: string | null | undefined;
  heading: string;
  /** Set this to true when the change plan page appears inside an inline upgrade nudge. */
  isEmbeddedInInlineUpgrade?: boolean;
  subheading?: string;
};

const accountNameCss = css`
  text-decoration: underline;
`;

const headerCss = css`
  margin-bottom: 4rem;
`;

const headingCss = css`
  color: ${Colors.deepSpace};
  font-size: 1.8em;
  font-weight: 600;
  margin-top: 1em;
  padding: 0;
  text-align: center;
`;

const subHeadingCss = css`
  color: ${Colors.steel};
  font-size: 1em;
  margin-top: 20px;
  text-align: center;
`;

export const ChangePlanHeader = (props: Props) => {
  const formattedCompanyName = formatCompanyName(props.companyName);

  const standardContent = props.subheading && (
    <div css={subHeadingCss}>
      {props.subheading}: <span css={accountNameCss}>{props.accountName}</span>{' '}
      {formattedCompanyName}
    </div>
  );

  const inlineUpgradeHeaderContent = (
    <Text color="gray60" tag="p" textAlign="center" type="smallPrint1">
      You're upgrading the account{' '}
      <span style={{ textDecoration: 'underline' }}>{props.accountName}</span>
      {formattedCompanyName ? ' ' + formattedCompanyName : null}. Have questions
      about what's included in your plan?{' '}
      <Link href="/app/billing/plans">Compare plans and pricing</Link>.
    </Text>
  );

  return (
    <header css={headerCss}>
      <h1 css={headingCss}>{props.heading}</h1>
      {props.isEmbeddedInInlineUpgrade
        ? inlineUpgradeHeaderContent
        : standardContent}
    </header>
  );
};
